import axios from "axios";
import { useEffect, useState } from "react";
import axiosInstant from "../../../axiosInstant";
import { mergeUniqueBy } from "../../../utils/collection";

export default function SearchAuction(page, auctionID, search, searchCat, artistRowID) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [lotdata, setLot] = useState([]);
  const [hasMore, setHasMore] = useState(true); 
  const [errorMsg, setErrorMsg] = useState("");

  // ✅ FIX: I-reset ang lahat kapag nagpalit ng filter parameter
  useEffect(() => {
    setLot([]);
    setHasMore(true); // Eto ang importante para payagan ang bagong fetch
    setError(false);
  }, [auctionID, search, searchCat, artistRowID]);

  useEffect(() => {
    // ✅ 1. GUARD: Pag alam nating wala nang records, stop.
    // Pero hayaan tumuloy kung page 1 (dahil baka bagong filter ito)
    if (!hasMore && page > 1) return; 

    setLoading(true);
    let cancel;

    const fetchData = async () => {
      try {
        const res = await axiosInstant({
          method: "GET",
          url: `private-sales/lot?id=&pgroup=PRIVATE_SALE&search=${search || ""}&cat=${searchCat || ""}&page=${page || 1}&artist_id=${artistRowID || ""}`,
          cancelToken: new axios.CancelToken((c) => (cancel = c)),
        });

        if (res.data.status === true && res.data.msg && res.data.msg.length > 0) {
          setLot((prev) =>
            mergeUniqueBy(prev, res.data.msg, (item) => item.data.id)
          );
          setHasMore(true); 
        } else {
          setHasMore(false); // Dito titigil ang susunod na calls
        }
      } catch (e) {
        if (axios.isCancel(e)) return;
        
        const resData = e.response?.data;
        // ✅ 2. CATCH: Kung "no record found" o success: false, i-stop ang hasMore
        if (resData?.sucess === false || resData?.status === false || resData?.msg?.toLowerCase().includes("no record")) {
          setHasMore(false);
          setError(false); // Hindi error, end of result lang
        } else {
          setError(true);
          setErrorMsg(resData?.msg || "Error");
          setHasMore(false);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => cancel && cancel();
  }, [page, auctionID, search, searchCat, artistRowID]);

  return { loading, error, lotdata, hasMore, errorMsg };
}